import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/tenants.json';
import ar from './i18n/ar/tenants.json';

registerFeatureI18n('adminTenants', { en, ar });

export { TenantsPage } from './TenantsPage';
export { TenantDetailPage } from './TenantDetailPage';
